import React from "react";
import { Quote, ShieldCheck, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CompromissoVendr() {
  return;
}